export const MEDIA_AGENCIES_META_DESCRIPTION_BG =
  "Perceptica подпомага медийните агенции с анализ преди кампанията, мониторинг в реално време и интегрирани отчети за платени и органични резултати.";
